import z from 'zod'

import { zh } from '@/libs/utils/zod'

const ProductCategory = z.object({
  outletId: z.string(),
  name: z.string(),
  isActive: z.boolean(),
})

const ProductCategorySelectDto = z.object({
  ...ProductCategory.shape,
  ...zh.metadata.shape,
})

type ProductCategorySelectDto = z.infer<typeof ProductCategorySelectDto>

const ProductCategoryBodyDto = z.object({
  ...ProductCategory.shape,
})

type ProductCategoryBodyDto = z.infer<typeof ProductCategoryBodyDto>

export { ProductCategorySelectDto, ProductCategoryBodyDto }
